import { render, staticRenderFns } from "./TeamNewInviteModal.vue?vue&type=template&id=48a5500a&scoped=true&"
import script from "./TeamNewInviteModal.vue?vue&type=script&lang=js&"
export * from "./TeamNewInviteModal.vue?vue&type=script&lang=js&"
import style0 from "./TeamNewInviteModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a5500a",
  null
  
)

export default component.exports